export default __webpack_public_path__ + "static/media/line-stock.1a61a40a.svg";